<template>
    <div
        ref="viewer"
        class="BpmnViewer"
    >
        <div
            v-if="zoomControls"
            class="ZoomControls"
        >
            <QBtn
                icon="add"
                flat
                round
                dense
                color="primary"
                @click="handleZoomIn"
            >
                <QTooltip>
                    {{ $t('general.zoomIn') }}
                </QTooltip>
            </QBtn>
            <QBtn
                icon="remove"
                flat
                round
                dense
                color="primary"
                @click="handleZoomOut"
            >
                <QTooltip>
                    {{ $t('general.zoomOut') }}
                </QTooltip>
            </QBtn>
            <QBtn
                icon="adjust"
                flat
                round
                dense
                color="primary"
                @click="handleResetZoom"
            >
                <QTooltip>
                    {{ $t('visualization.centerChart') }}
                </QTooltip>
            </QBtn>
        </div>
        <QBtn
            v-else-if="centerButton"
            icon="adjust"
            unelevated
            color="white"
            :class="tabClass"
            textColor="primary"
            size="lg"
            padding="xs"
            round
            @click="handleResetZoom"
        >
            <QTooltip>
                {{ $t('visualization.centerChart') }}
            </QTooltip>
        </QBtn>
    </div>
</template>
<script>
import VueTypes from 'vue-types'
import BpmnViewer from 'bpmn-js/lib/NavigatedViewer'
import { notifyError } from '@/api'

export default {
    name: 'BpmnViewer',
    components: {
    },
    props: {
        data: VueTypes.string,
        centerButton: VueTypes.bool.def(true),
        zoomControls: VueTypes.bool.def(false),
        height: VueTypes.oneOfType([VueTypes.number, VueTypes.string]).def(300),
    },
    data() {
        return {
            viewer: undefined,
            tabClass: undefined,
        }
    },
    watch: {
        data: {
            handler() {
                this.renderDiagram()
            },
        },
    },
    mounted() {
        this.calcCenterGraphButtonClass()
        this.viewer = new BpmnViewer({
            container: this.$refs.viewer,
        })
        this.renderDiagram()
    },
    methods: {
        handleError(err) {
            notifyError(this.$t('visualization.bpmnNotShowable: ') + err)
        },

        renderDiagram() {
            this.calcCenterGraphButtonClass()
            if (!this.viewer || !this.data) return

            this.calcHeightAndWidth()
            this.viewer.importXML(this.data)
                .then(() => {
                    const canvas = this.viewer.get('canvas')
                    canvas.zoom('fit-viewport', 'auto')
                })
                .catch((err) => {
                    this.handleError(err)
                })
        },

        handleResetZoom() {
            if (!this.viewer) return
            const canvas = this.viewer.get('canvas')
            canvas.zoom('fit-viewport', 'auto')
        },

        handleZoomIn() {
            this.applyZoomDelta(0.2)
        },

        handleZoomOut() {
            this.applyZoomDelta(-0.2)
        },

        applyZoomDelta(delta) {
            if (!this.viewer) return
            const canvas = this.viewer.get('canvas')
            const current = canvas.zoom()
            const next = Math.max(0.2, Math.min(4, current + delta))
            canvas.zoom(next)
        },

        calcHeightAndWidth() {
            const container = this.$refs.viewer
            if (!container) return
            const height = typeof this.height === 'number' ? `${this.height}px` : this.height
            container.style.height = height
            container.style.width = '100%'
        },

        calcCenterGraphButtonClass() {
            this.tabClass = this.$parent.$options.name === 'BaseTransition' ? 'CenterBtnConformance' : 'CenterBtnModelPreview'
        },
    },
}
</script>
<style scoped lang="scss">
    .BpmnViewer {
        position: relative;
        border: 1px solid $gray-05;
        border-radius: 10px;
    }

    .ZoomControls {
        position: absolute;
        top: 6px;
        right: 6px;
        z-index: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: rgba($white, 0.9);
        border: 1px solid $gray-04;
        border-radius: 10px;
        padding: 4px;
    }
    .CenterBtnConformance {
        position: absolute;
        background-color: transparent;
        top: 0px;
        right: 0px;
        z-index: 1;
    }
    .CenterBtnModelPreview {
        position: absolute;
        top: 0px;
        right: 0px;
        z-index: 1;
    }
</style>
